import { TrackingJsonService } from '../../api/services';
import { StayPrefComponent } from './stay-pref/stay-pref.component';
import { ComponentsModule } from '../../components';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StayPreferenceComponent } from '../../components/stay-preference/stay-preference.component';
// import { CommonActionsDelegate } from '../../api/delegates/common-actions.delegate';

import { Routes, RouterModule } from '@angular/router';
// import { StayPreferenceComponent } from '../../components/stay-preference/stay-preference.component';
const routes: Routes = [
    { path: '', component: StayPrefComponent }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        ComponentsModule
    ],
    declarations: [
        StayPrefComponent
    ],
    exports: [
        RouterModule,
        StayPrefComponent,
        StayPreferenceComponent
    ],
    providers: [
        // CommonActionsDelegate,
        TrackingJsonService
    ]
})
export class StayPrefModule {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/stay-pref/stay-pref.module.ts